export default "__VITE_ASSET__Cs6R4O5m__"